module.exports = __webpack_public_path__ + "img/VIDEOJUEGOS.bf5ecd81.png";